import { css } from "styled-components";
import token from "styled-token";
export var ListboxOptionMetaMixin = token("ListboxOption.metaColor", function (color) {
  return css(["color:", ";"], color);
});